import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Row } from '../components';
import { renderDndColumns } from './renderDndColumns';
import { useDndRow } from './useDndRow';
export const DndRow = memo(function DndRow({ id, index, group, columns, itemProps, ...rowProps }) {
    const { ref, dragHandleRef, targetRef, isDragging } = useDndRow({ id, index, group });
    return (_jsx(Row, { ref: ref, targetRef: targetRef, isDragging: isDragging, ...rowProps, children: renderDndColumns(columns, { ...itemProps, dragHandleRef }) }));
});
